import Vue from 'vue';
import Router from 'vue-router';
import store from "./store";

//花名册管理
import CustomerRoster from "./views/projectManage/customerRoster.vue";
import RecoedDetails from "./views/employee/recoedDetails.vue";
import FinancialError from "./views/financeManage/financialError.vue";
import FinancialRoster from "./views/financeManage/financialRoster.vue";
// import xz from "common"



Vue.use(Router)

// 设置不同权限首页路由
let firstRoutes
let firstRoute
if (localStorage.router) {
  // firstRoutes = JSON.parse(localStorage.router)
  // firstRoute = firstRoutes[0].path
  firstRoute = "/staging"
} else {
  firstRoute = '/login'
}
// console.log('ddd',  JSON.parse(localStorage.router))
export const defaultRoutes = [{
    path: '/',
    redirect: firstRoute
  },
  {
    checked: "false",
    name: 'login',
    path: '/login',
    meta: {
      badge: "",
      checked: "false",
      icon: "navigation-icon-user",
      operation: "",
      title: "login"
    },
    component: () => import('@/views/loginItem'),
    powercode: "",
    powermsg: "",
    powername: "",
    hidden: true
  },
  {
    path: '/employee-customerRoster',
    component: CustomerRoster,
    name: 'CustomerRoster',
    meta: {
      title: '',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/customerList'
    },
    powercode: "",
    powermsg: "",
    powername: "",
    hidden: true
  }, {
    path: '/employee-recoedDetails',
    component: RecoedDetails,
    name: 'RecoedDetails',
    meta: {
      title: '',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/customerList'
    },
    powercode: "",
    powermsg: "",
    powername: "",
    hidden: true
  }, {
    path: '/employee-rosterErroe',
    component: () => import('@/views/employee/rosterErroe.vue'),
    name: 'rosterErroe',
    meta: {
      title: '花名册勘误',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/customerList'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/employee-importField',
    component: () => import('@/views/system/importField.vue'),
    name: 'importField',
    meta: {
      title: '导入字段管理',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/fieldMaintenance'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/employee-historyDetail',
    component: () => import('@/views/employee/historyDetail.vue'),
    name: 'historyDetail',
    meta: {
      title: '历史花名册详情',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  },
  {
    path: '/sameRepeatList',
    component: () => import('@/views/notice/sameRepeatList.vue'),
    name: 'sameRepeatList',
    meta: {
      title: '同公司多次入职列表',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/repeatT'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  },
  {
    path: '/financialRoster',
    component: FinancialRoster,
    name: 'financialRoster',
    meta: {
      title: '',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: ''
    },
    powercode: "",
    powermsg: "",
    powername: ""
  },
  {
    path: '/financialError',
    component: FinancialError,
    name: 'financialError',
    meta: {
      title: '',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: ''
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/employee-fnnfiled',
    component: () => import('@/views/financeManage/employee-fnnfiled.vue'),
    name: 'fieldManage',
    meta: {
      title: '财务导入字段管理',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: ''
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/financialSummary',
    component: () => import('@/views/financeManage/financialSummary.vue'),
    name: 'financialSummary',
    meta: {
      title: '财务报表',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: ''
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/addProject',
    component: () => import('@/views/projectManage/addProject.vue'),
    name: 'addProject',
    meta: {
      title: '修改项目',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/projectList'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  },
  {
    path: '/employee-editMyPassword',
    component: () => import('@/views/my/editMyPassword.vue'),
    name: 'editMyPassword',
    meta: {
      title: '修改账户',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: ''
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/checkDetail',
    component: () => import('@/views/financeManage/checkDetail.vue'),
    name: 'checkDetail',
    meta: {
      title: '数据源校验详情',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/employee-fnnchis'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/dtlVideo',
    component: () => import('@/views/doc/dtlVideo.vue'),
    name: 'dtlVideo',
    meta: {
      title: '系统使用视频',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: ''
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/dtlDoc',
    component: () => import('@/views/doc/dtlDoc.vue'),
    name: 'dtlDoc',
    meta: {
      title: '使用手册',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: ''
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/dtlSysDoc',
    component: () => import('@/views/doc/dtlSysDoc.vue'),
    name: 'dtlSysDoc',
    meta: {
      title: '管理制度',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: ''
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/dtlDocPdf',
    component: () => import('@/views/doc/dtlDocPdf.vue'),
    name: 'dtlDocPdf',
    meta: {
      title: '杰博数字化系统管理制度',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: ''
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/blacklist',
    component: () => import('@/views/projectManage/blacklist.vue'),
    name: 'blacklist',
    meta: {
      title: '黑名单雇员',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/customerList'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/historicalRoster',
    component: () => import('@/views/employee/historicalRoster.vue'),
    name: 'historicalRoster',
    meta: {
      title: '历史花名册',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/customerList'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/operationRecord',
    component: () => import('@/views/projectManage/operationRecord.vue'),
    name: 'operationRecord',
    meta: {
      title: '导入导出记录',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/customerList'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/demandUpdate',
    component: () => import('@/views/employee/demandUpdate.vue'),
    name: 'demandUpdate',
    meta: {
      title: '招聘需求更新',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/recruitDemand'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/demandDetail',
    component: () => import('@/views/employee/demandDetail.vue'),
    name: 'demandDetail',
    meta: {
      title: '招聘需求详情',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/recruitDemand'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/dtlResource',
    component: () => import('@/views/employee/dtlResource.vue'),
    name: 'dtlResource',
    meta: {
      title: '资源详情',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: ''
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/resImportList',
    component: () => import('@/views/employee/resImportList.vue'),
    name: 'resImportList',
    meta: {
      title: '导入导出记录',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/resImportList'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/recruitSet',
    component: () => import('@/views/employee/recruitSet.vue'),
    name: 'recruitSet',
    meta: {
      title: '招聘设置',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/employeeSet'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/divideList',
    component: () => import('@/views/employee/divideList.vue'),
    name: 'divideList',
    meta: {
      title: '分配记录',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: ''
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/noteSendList',
    component: () => import('@/views/employee/noteSendList.vue'),
    name: 'noteSendList',
    meta: {
      title: '通知记录',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/signupList'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/candidate',
    component: () => import('@/views/weCom/candidate.vue'),
    name: 'candidate',
    meta: {
      title: '候选人画像',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/resume',
    component: () => import('@/views/weCom/resume.vue'),
    name: 'resume',
    meta: {
      title: '候选人简历',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/editResume',
    component: () => import('@/views/weCom/editResume.vue'),
    name: 'editResume',
    meta: {
      title: '编辑简历',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/matching',
    component: () => import('@/views/weCom/matching.vue'),
    name: 'matching',
    meta: {
      title: '人岗匹配',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/chat',
    component: () => import('@/views/weCom/chat.vue'),
    name: 'chat',
    meta: {
      title: '聊天机器人',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/processRecord',
    component: () => import('@/views/employee/processRecord.vue'),
    name: 'processRecord',
    meta: {
      title: '流程记录',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/signupList'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/entryHandle',
    component: () => import('@/views/employee/entryHandle.vue'),
    name: 'entryHandle',
    meta: {
      title: '入职办理',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/signupList'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/enrollRegist',
    component: () => import('@/views/employee/enrollRegist.vue'),
    name: 'enrollRegist',
    meta: {
      title: '入职登记',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/signupList'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/importErrorList',
    component: () => import('@/views/employee/importErrorList.vue'),
    name: 'importErrorList',
    meta: {
      title: '导入错误记录',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/resImportList'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/socialBill',
    component: () => import('@/views/employee/socialBill.vue'),
    name: 'socialBill',
    meta: {
      title: '社保账单',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/resImportList'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/importBill',
    component: () => import('@/views/employee/importBill.vue'),
    name: 'importBill',
    meta: {
      title: '账单导入',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/resImportList'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/payFees',
    component: () => import('@/views/employee/payFees.vue'),
    name: 'payFees',
    meta: {
      title: '缴费标准',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/resImportList'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/addPayFee',
    component: () => import('@/views/employee/addPayFee.vue'),
    name: 'addPayFee',
    meta: {
      title: '手工新增',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/resImportList'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/socialInsurance',
    component: () => import('@/views/employee/socialInsurance.vue'),
    name: 'socialInsurance',
    meta: {
      title: '社保设置',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/resImportList'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/marketingLead',
    component: () => import('@/views/product/marketingLead.vue'),
    name: 'marketingLead',
    meta: {
      title: '营销线索',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/marketingRadar'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/updateSupply',
    component: () => import('@/views/supplierManage/updateSupply.vue'),
    name: 'updateSupply',
    meta: {
      title: '更新施工队',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/supplierManage'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/updateTeamMember',
    component: () => import('@/views/supplierManage/updateTeamMember.vue'),
    name: 'updateTeamMember',
    meta: {
      title: '更新施工队员',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/teamMembers'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/addNewCust',
    component: () => import('@/views/product/addNewCust.vue'),
    name: '新建背调客户',
    meta: {
      title: '新建背调客户',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/bgSet'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/bgQRcodeList',
    component: () => import('@/views/product/bgQRcodeList.vue'),
    name: '闪查二维码',
    meta: {
      title: '闪查二维码',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/bgQRcodeList'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/supplyDetail',
    component: () => import('@/views/supplierManage/supplyDetail.vue'),
    name: 'supplyDetail',
    meta: {
      title: '施工详情',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/supplierManage'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/teamMemberDetail',
    component: () => import('@/views/supplierManage/teamMemberDetail.vue'),
    name: 'teamMemberDetail',
    meta: {
      title: '队员详情',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/teamMembers'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/historyReport',
    component: () => import('@/views/supplierManage/historyReport.vue'),
    name: 'historyReport',
    meta: {
      title: '历史记录',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/verifySummary'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/feeDetail',
    component: () => import('@/views/supplierManage/feeDetail.vue'),
    name: 'feeDetail',
    meta: {
      title: '费用单详情',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/supplyLog'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/generatedRecords',
    component: () => import('@/views/supplierManage/generatedRecords.vue'),
    name: 'generatedRecords',
    meta: {
      title: '实发报表',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/verifySummary'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/chatWeb',
    component: () => import('@/views/jobChat/chatWeb.vue'),
    name: 'chatWeb',
    meta: {
      title: '杰博chatWeb',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: ''
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/receiptConfirmation',
    component: () => import('@/views/supplierManage/receiptConfirmation.vue'),
    name: 'receiptConfirmation',
    meta: {
      title: '确认收款人数据',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/verifySummary'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/home',
    component: () => import('@/views/jobChat/home.vue'),
    name: 'home',
    meta: {
      title: '杰博chatWeb',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: ''
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/hello',
    component: () => import('@/views/weCom/hello.vue'),
    name: 'hello',
    meta: {
      title: '111',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: ''
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/headHunting',
    component: () => import('@/views/product/headHunting.vue'),
    name: 'headHunting',
    meta: {
      title: '猎头线索雷达',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/marketingRadar'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/teamReminder',
    component: () => import('@/views/supplierManage/teamReminder.vue'),
    name: 'teamReminder',
    meta: {
      title: '提醒',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: ''
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/recertification',
    component: () => import('@/views/supplierManage/recertification.vue'),
    name: 'recertification',
    meta: {
      title: '重新认证',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/supplierManage'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/addPosition',
    component: () => import('@/views/system/addPosition.vue'),
    name: 'addPosition',
    meta: {
      title: '创建岗位',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/postManage'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/updateRoles',
    component: () => import('@/views/system/updateRoles.vue'),
    name: 'updateRoles',
    meta: {
      title: '更新角色',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/roles'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/updateEmployee',
    component: () => import('@/views/system/updateEmployee.vue'),
    name: 'updateEmployee',
    meta: {
      title: '更新员工',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/departMember'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/employeeDtl',
    component: () => import('@/views/system/employeeDtl.vue'),
    name: 'employeeDtl',
    meta: {
      title: '查看员工',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/departMember'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/collectSet',
    component: () => import('@/views/product/collectSet.vue'),
    name: 'collectSet',
    meta: {
      title: '区域配置',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/radarManage'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/enterpriseLibrary',
    component: () => import('@/views/product/enterpriseLibrary.vue'),
    name: 'enterpriseLibrary',
    meta: {
      title: '企业库',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/radarManage'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/processData',
    component: () => import('@/views/product/processData.vue'),
    name: 'processData',
    meta: {
      title: '流程数据',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/radarManage'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/taskList',
    component: () => import('@/views/product/taskList.vue'),
    name: 'taskList',
    meta: {
      title: '采集任务',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/radarManage'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/recruitManage',
    component: () => import('@/views/employee/recruitManage.vue'),
    name: 'recruitManage',
    meta: {
      title: '标签管理',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/employeeSet'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/addLegSub',
    component: () => import('@/views/system/addLegSub.vue'),
    name: 'addLegSub',
    meta: {
      title: '新增法务主体',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/legalMaintenance'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/addSsy',
    component: () => import('@/views/doc/addSsy.vue'),
    name: 'addSsy',
    meta: {
      title: '新增社保',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/israGudSet'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/addCIn',
    component: () => import('@/views/doc/addCIn.vue'),
    name: 'addCIn',
    meta: {
      title: '新增商保',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/israGudSet'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/addCase',
    component: () => import('@/views/doc/addCase.vue'),
    name: 'addCase',
    meta: {
      title: '新增案例',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/successCaseSet'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/addCompanyProfile',
    component: () => import('@/views/doc/addCompanyProfile.vue'),
    name: 'addCompanyProfile',
    meta: {
      title: '新增公司介绍',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/successCaseSet'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/addTemplate',
    component: () => import('@/views/doc/addTemplate.vue'),
    name: 'addTemplate',
    meta: {
      title: '新增合同模板',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/successCaseSet'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/addWeb',
    component: () => import('@/views/doc/addWeb.vue'),
    name: 'addWeb',
    meta: {
      title: '新增招投标网站',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/biddingWebSet'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/bidInfo',
    component: () => import('@/views/doc/bidInfo.vue'),
    name: 'bidInfo',
    meta: {
      title: '投标资料',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/biddingWebSet'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/companyMaterials',
    component: () => import('@/views/doc/companyMaterials.vue'),
    name: 'companyMaterials',
    meta: {
      title: '公司宣传资料',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/biddingWebSet'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/contractTemplateSet',
    component: () => import('@/views/doc/contractTemplateSet.vue'),
    name: 'contractTemplateSet',
    meta: {
      title: '合同模板管理',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/successCaseSet'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/companyProfileSet',
    component: () => import('@/views/doc/companyProfileSet.vue'),
    name: 'companyProfileSet',
    meta: {
      title: '公司介绍管理',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/successCaseSet'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/quotationGuiSet',
    component: () => import('@/views/doc/quotationGuiSet.vue'),
    name: 'quotationGuiSet',
    meta: {
      title: '报价指导设置',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/successCaseSet'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/sendModelSet',
    component: () => import('@/views/employee/sendModelSet.vue'),
    name: 'sendModelSet',
    meta: {
      title: '通知模板配置',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/eleApplication',
    component: () => import('@/views/employee/eleApplication.vue'),
    name: 'eleApplication',
    meta: {
      title: '电子签约报名',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/empApplication',
    component: () => import('@/views/employee/empApplication.vue'),
    name: 'empApplication',
    meta: {
      title: '入职登记',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/interviewApplication',
    component: () => import('@/views/employee/interviewApplication.vue'),
    name: 'interviewApplication',
    meta: {
      title: '面试登记',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/ea',
    component: () => import('@/views/AI/ea.vue'),
    name: 'ea',
    meta: {
      title: '入职登记',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/ia',
    component: () => import('@/views/AI/ia.vue'),
    name: 'ia',
    meta: {
      title: '入职登记',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/en',
    component: () => import('@/views/AI/en.vue'),
    name: 'en',
    meta: {
      title: '入职登记',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/in',
    component: () => import('@/views/AI/in.vue'),
    name: 'in',
    meta: {
      title: '入职登记',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/SelfDeparture',
    component: () => import('@/views/employee/SelfDeparture.vue'),
    name: 'SelfDeparture',
    meta: {
      title: '自离公告',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/agencyRec',
    component: () => import('@/views/employee/agencyRec.vue'),
    name: 'agencyRec',
    meta: {
      title: '代理招聘',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/insuranceH5',
    component: () => import('@/views/employee/insuranceH5.vue'),
    name: 'insuranceH5',
    meta: {
      title: '商保h5',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/bgApplication',
    component: () => import('@/views/employee/bgApplication.vue'),
    name: 'bgApplication',
    meta: {
      title: '背调报名',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/employee-exportRecordList',
    component: () => import('@/views/reportForms/exportRecordList'),
    name: 'exportRecordList',
    meta: {
      title: '报表导出记录',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/exportRecordList'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/backgroundCheckRecord',
    component: () => import('@/views/product/backgroundCheckRecord.vue'),
    name: 'backgroundCheckRecord',
    meta: {
      title: '背调报告',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/backgroundCheck'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/legalSubjectInfo',
    component: () => import('@/views/doc/legalSubjectInfo.vue'),
    name: 'legalSubjectInfo',
    meta: {
      title: '法务主体基础信息',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/addLegSub',
    component: () => import('@/views/system/addLegSub.vue'),
    name: 'addLegSub',
    meta: {
      title: '新增法务主体',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/legalMaintenance'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/addSsy',
    component: () => import('@/views/doc/addSsy.vue'),
    name: 'addSsy',
    meta: {
      title: '新增社保',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/israGudSet'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/addCIn',
    component: () => import('@/views/doc/addCIn.vue'),
    name: 'addCIn',
    meta: {
      title: '新增商保',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/israGudSet'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/addCase',
    component: () => import('@/views/doc/addCase.vue'),
    name: 'addCase',
    meta: {
      title: '新增案例',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/successCaseSet'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/addCompanyProfile',
    component: () => import('@/views/doc/addCompanyProfile.vue'),
    name: 'addCompanyProfile',
    meta: {
      title: '新增公司介绍',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/successCaseSet'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/addTemplate',
    component: () => import('@/views/doc/addTemplate.vue'),
    name: 'addTemplate',
    meta: {
      title: '新增合同模板',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/successCaseSet'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/addWeb',
    component: () => import('@/views/doc/addWeb.vue'),
    name: 'addWeb',
    meta: {
      title: '新增招投标网站',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/biddingWebSet'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/quotationGui',
    component: () => import('@/views/doc/quotationGui.vue'),
    name: 'quotationGui',
    meta: {
      title: '报价指导',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/gatherSet',
    component: () => import('@/views/financeManage/gatherSet.vue'),
    name: 'gatherSet',
    meta: {
      title: '采集设置',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/contractTemplateSet',
    component: () => import('@/views/doc/contractTemplateSet.vue'),
    name: 'contractTemplateSet',
    meta: {
      title: '合同模板管理',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/companyProfileSet',
    component: () => import('@/views/doc/companyProfileSet.vue'),
    name: 'companyProfileSet',
    meta: {
      title: '公司介绍管理',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/quotationGuiSet',
    component: () => import('@/views/doc/quotationGuiSet.vue'),
    name: 'quotationGuiSet',
    meta: {
      title: '报价指导设置',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/successCaseSet'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/underGuarantee',
    component: () => import('@/views/employee/underGuarantee'),
    name: 'underGuarantee',
    meta: {
      title: '在保人员',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/underGuarantee2',
    component: () => import('@/views/employee/underGuarantee2'),
    name: 'underGuarantee2',
    meta: {
      title: '在保人员',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/onWork',
    component: () => import('@/views/employee/onWork'),
    name: 'onWork',
    meta: {
      title: '在职名单',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/settlementClaims',
    component: () => import('@/views/employee/settlementClaims'),
    name: 'settlementClaims',
    meta: {
      title: '报案理赔',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/lapse',
    component: () => import('@/views/employee/lapse'),
    name: 'lapse',
    meta: {
      title: '失效名单',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/premiumBill',
    component: () => import('@/views/employee/premiumBill'),
    name: 'premiumBill',
    meta: {
      title: '保费账单',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/firstPaymentList',
    component: () => import('@/views/employee/firstPaymentList'),
    name: 'firstPaymentList',
    meta: {
      title: '首次缴费名单',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/firstPaymentList2',
    component: () => import('@/views/employee/firstPaymentList2'),
    name: 'firstPaymentList2',
    meta: {
      title: '首次缴费名单',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/submitList',
    component: () => import('@/views/employee/submitList'),
    name: 'submitList',
    meta: {
      title: '商保提交记录',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/paymentList',
    component: () => import('@/views/employee/paymentList'),
    name: 'paymentList',
    meta: {
      title: '缴费名单',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/paymentList2',
    component: () => import('@/views/employee/paymentList2'),
    name: 'paymentList2',
    meta: {
      title: '缴费名单',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/cInsureLog',
    component: () => import('@/views/employee/cInsureLog'),
    name: 'cInsureLog',
    meta: {
      title: '操作日志',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/salaryProcessSet',
    component: () => import('@/views/system/salaryProcessSet'),
    name: 'salaryProcessSet',
    meta: {
      title: '发薪流程管理',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/calcSalary',
    component: () => import('@/views/financeManage/calcSalary'),
    name: 'calcSalary',
    meta: {
      title: '算薪',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/projectSet',
    component: () => import('@/views/financeManage/projectSet'),
    name: 'projectSet',
    meta: {
      title: '指定项目配置',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/addCalcSalary',
    component: () => import('@/views/financeManage/addCalcSalary'),
    name: 'addCalcSalary',
    meta: {
      title: '新增算薪',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/basicDataList',
    component: () => import('@/views/rae/basicDataList'),
    name: 'basicDataList',
    meta: {
      title: '社保夯实率',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/basicDataList'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/injuryWarn',
    component: () => import('@/views/risk/injuryWarn'),
    name: 'injuryWarn',
    meta: {
      title: '工伤与投保预警',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/injuryWarn'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/urgeCenter',
    component: () => import('@/views/risk/urgeCenter'),
    name: 'urgeCenter',
    meta: {
      title: '催办消息中心',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/urgeCenter'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/riskAnalysis',
    component: () => import('@/views/risk/riskAnalysis'),
    name: 'riskAnalysis',
    meta: {
      title: '预警分析中心',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/riskAnalysis'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/riskCockpit',
    component: () => import('@/views/risk/riskCockpit'),
    name: 'riskCockpit',
    meta: {
      title: '风控决策驾驶舱',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/riskCockpit'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/laborCompliance',
    component: () => import('@/views/risk/laborCompliance'),
    name: 'laborCompliance',
    meta: {
      title: '用工合规预警',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/laborCompliance'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/arUncleared',
    component: () => import('@/views/risk/arUncleared'),
    name: 'arUncleared',
    meta: {
      title: '应收暂支未清预警',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/arUncleared'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/payrollWarn',
    component: () => import('@/views/risk/payrollWarn'),
    name: 'payrollWarn',
    meta: {
      title: '欠薪预警',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/payrollWarn'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/socialRateWarn',
    component: () => import('@/views/risk/socialRate'),
    name: 'socialRateWarn',
    meta: {
      title: '社保夯实率预警',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/socialRateWarn'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  },{
    path: '/offlineSalary',
    component: () => import('@/views/financeManage/offlineSalary'),
    name: 'offlineSalary',
    meta: {
      title: '线下发薪数据维护',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/setNewSalaryTemp',
    component: () => import('@/views/financeManage/setNewSalaryTemp'),
    name: 'setNewSalaryTemp',
    meta: {
      title: '新建模板',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/staging',
    component: () => import('@/views/financeManage/staging'),
    name: 'staging',
    meta: {
      title: '工作台',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/salaryApproval',
    component: () => import('@/views/financeManage/salaryApproval'),
    name: 'salaryApproval',
    meta: {
      title: '薪酬审批',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/payment',
    component: () => import('@/views/financeManage/payment'),
    name: 'payment',
    meta: {
      title: '打款',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/approveDtl',
    component: () => import('@/views/financeManage/approveDtl'),
    name: 'approveDtl',
    meta: {
      title: '审批详情',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/paymentDtl',
    component: () => import('@/views/financeManage/paymentDtl'),
    name: 'paymentDtl',
    meta: {
      title: '打款详情',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/returnRecord',
    component: () => import('@/views/financeManage/returnRecord'),
    name: 'returnRecord',
    meta: {
      title: '退回记录',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/reviewPay',
    component: () => import('@/views/financeManage/reviewPay'),
    name: 'reviewPay',
    meta: {
      title: '复核发薪',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/salarySet',
    component: () => import('@/views/financeManage/salarySet'),
    name: 'salarySet',
    meta: {
      title: '配置',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/PaymentManage',
    component: () => import('@/views/financeManage/PaymentManage'),
    name: 'PaymentManage',
    meta: {
      title: '到款管理',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/xftAbnormal',
    component: () => import('@/views/financeManage/xftAbnormal'),
    name: 'xftAbnormal',
    meta: {
      title: '薪福通异常',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/salaryDtl',
    component: () => import('@/views/financeManage/salaryDtl'),
    name: 'salaryDtl',
    meta: {
      title: '明细',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/salarySuccessDtl',
    component: () => import('@/views/financeManage/salarySuccessDtl'),
    name: 'salarySuccessDtl',
    meta: {
      title: '发薪成功明细',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/zeroRepairList',
    component: () => import('@/views/financeManage/zeroRepairList'),
    name: 'zeroRepairList',
    meta: {
      title: '零收入申报列表',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/tePaymentDtl',
    component: () => import('@/views/rae/tePaymentDtl'),
    name: 'reaPaymentDtl',
    meta: {
      title: '暂支明细',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/trendChart',
    component: () => import('@/views/rae/trendChart'),
    name: 'trendChart',
    meta: {
      title: '趋势图',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/logPayment',
    component: () => import('@/views/rae/logPayment'),
    name: 'logPayment',
    meta: {
      title: '日志报销打款',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/advList',
    component: () => import('@/views/rae/advList'),
    name: 'advList',
    meta: {
      title: '垫资',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/logReiDtl',
    component: () => import('@/views/rae/logReiDtl'),
    name: 'logReiDtl',
    meta: {
      title: '报销单',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/invoiceDataQuery',
    component: () => import('@/views/rae/invoiceDataQuery'),
    name: 'invoiceDataQuery',
    meta: {
      title: '发票数据查询',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/tePayment',
    component: () => import('@/views/rae/tePayment'),
    name: 'raePayment',
    meta: {
      title: '暂支打款',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/accountsReceivable',
    component: () => import('@/views/rae/accountsReceivable'),
    name: 'accountsReceivable',
    meta: {
      title: '应收账款',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/finCost',
    component: () => import('@/views/rae/finCost'),
    name: 'finCost',
    meta: {
      title: '财务成本',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/advCost',
    component: () => import('@/views/rae/advCost'),
    name: 'advCost',
    meta: {
      title: '垫支成本',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/reportManageIncome',
    component: () => import('@/views/rae/reportManageIncome'),
    name: 'reportManageIncome',
    meta: {
      title: '管理报表收入',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  },
  // {
  //   path: '/custStaging',
  //   component: () => import('@/views/cust/custStaging'),
  //   name: 'custStaging',
  //   meta: { title: '工作台_客户在线', checked: false,badge: '',icon: 'table' },
  //   powercode: "",
  //   powermsg: "",
  //   powername: ""
  // },{
  //   path: '/custEmp',
  //   component: () => import('@/views/cust/custEmp'),
  //   name: 'custEmp',
  //   meta: { title: '雇员_客户在线', checked: false,badge: '',icon: 'table' },
  //   powercode: "",
  //   powermsg: "",
  //   powername: ""
  // },{
  //   path: '/custEle',
  //   component: () => import('@/views/cust/custEle'),
  //   name: 'custEle',
  //   meta: { title: '电子签约_客户在线', checked: false,badge: '',icon: 'table' },
  //   powercode: "",
  //   powermsg: "",
  //   powername: ""
  // },{
  //   path: '/custSalary',
  //   component: () => import('@/views/cust/custSalary'),
  //   name: 'custSalary',
  //   meta: { title: '薪酬_客户在线', checked: false,badge: '',icon: 'table' },
  //   powercode: "",
  //   powermsg: "",
  //   powername: ""
  // },{
  //   path: '/custInvoice',
  //   component: () => import('@/views/cust/custInvoice'),
  //   name: 'custInvoice',
  //   meta: { title: '开票_客户在线', checked: false,badge: '',icon: 'table' },
  //   powercode: "",
  //   powermsg: "",
  //   powername: ""
  // },
  {
    path: '/finSet',
    component: () => import('@/views/rae/finSet'),
    name: 'finSet',
    meta: {
      title: '财务设置',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/coopBatchPay',
    component: () => import('@/views/rae/coopBatchPay'),
    name: 'coopBatchPay',
    meta: {
      title: '合作账户批量打款',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/logReimbursement',
    component: () => import('@/views/rae/logReimbursement'),
    name: 'logReimbursement',
    meta: {
      title: '报销单',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  },
  {
    path: '/balanceDtl',
    component: () => import('@/views/rae/balanceDtl'),
    name: 'balanceDtl',
    meta: {
      title: '结算单详情',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/invoicing'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  },
  {
    path: '/redInvoice',
    component: () => import('@/views/rae/redInvoice'),
    name: 'redInvoice',
    meta: {
      title: '红冲确认单',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/redInvoice'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  },
  {
    path: '/applyDtl',
    component: () => import('@/views/rae/applyDtl'),
    name: 'applyDtl',
    meta: {
      title: '开票申请详情',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/invoicing'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  },
  {
    path: '/submitApply',
    component: () => import('@/views/rae/submitApply'),
    name: 'submitApply',
    meta: {
      title: '提交申请',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/invoicing'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  },
  {
    path: '/updateInvoice',
    component: () => import('@/views/rae/updateInvoice'),
    name: 'updateInvoice',
    meta: {
      title: '更新开票',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/invoicing'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/noApplicationInv',
    component: () => import('@/views/rae/noApplicationInv'),
    name: 'noApplicationInv',
    meta: {
      title: '无申请开票',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/invoicing'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/settlement',
    component: () => import('@/views/rae/settlement'),
    name: 'settlement',
    meta: {
      title: '结算单',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/settlement'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/cashFlow',
    component: () => import('@/views/rae/cashFlow'),
    name: 'cashFlow',
    meta: {
      title: '现金流',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/cashFlow'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/settlementTask',
    component: () => import('@/views/AI/settlementTask'),
    name: 'settlementTask',
    meta: {
      title: '结算单任务',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/settlementTask'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/bankSet',
    component: () => import('@/views/AI/bankSet'),
    name: 'bankSet',
    meta: {
      title: '杰小金设置',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/settlementTask'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/taskSysSet',
    component: () => import('@/views/AI/taskSysSet'),
    name: 'taskSysSet',
    meta: {
      title: '任务看板系统设置',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/settlementTask'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/assignTasks',
    component: () => import('@/views/AI/assignTasks'),
    name: 'assignTasks',
    meta: {
      title: '安排任务',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/settlementTask'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/agentManage',
    component: () => import('@/views/AI/agentManage'),
    name: 'agentManage',
    meta: {
      title: 'agent管理',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/agentManage'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/toolManage',
    component: () => import('@/views/AI/toolManage'),
    name: 'toolManage',
    meta: {
      title: '工具管理',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/toolManage'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/batchJobManage',
    component: () => import('@/views/AI/batchJobManage'),
    name: 'batchJobManage',
    meta: {
      title: '批处理任务',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/batchJobManage'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/scheduledJobManage',
    component: () => import('@/views/AI/scheduledJobManage'),
    name: 'scheduledJobManage',
    meta: {
      title: '计划任务',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/scheduledJobManage'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/tz',
    component: () => import('@/views/AI/tz'),
    name: 'tz',
    meta: {
      title: '通知',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/settlementTask'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/taskDtl',
    component: () => import('@/views/AI/taskDtl'),
    name: 'taskDtl',
    meta: {
      title: '任务详情',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/settlementTask'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/onChainManage',
    component: () => import('@/views/block/onChainManage'),
    name: 'onChainManage',
    meta: {
      title: '上链任务管理',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/onChainManage'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/evidence',
    component: () => import('@/views/block/evidence'),
    name: 'evidence',
    meta: {
      title: '存证查询与验证',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/evidence'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/jobTask',
    component: () => import('@/views/AI/jobTask'),
    name: 'jobTask',
    meta: {
      title: '入职任务',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/settlementTask'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/collect',
    component: () => import('@/views/AI/collect'),
    name: 'collect',
    meta: {
      title: '信息采集',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/collect'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/ruleSet',
    component: () => import('@/views/AI/ruleSet'),
    name: 'ruleSet',
    meta: {
      title: '入职参保规则',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/settlementTask'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/taskSet',
    component: () => import('@/views/AI/taskSet'),
    name: 'taskSet',
    meta: {
      title: '任务缺省配置',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/settlementTask'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/dict',
    component: () => import('@/views/AI/dict'),
    name: 'dict',
    meta: {
      title: '增强学习',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/dict'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/dictDtl',
    component: () => import('@/views/AI/dictDtl'),
    name: 'dictDtl',
    meta: {
      title: '模板详情',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/dict'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/batchImportInv',
    component: () => import('@/views/rae/batchImportInv'),
    name: 'batchImportInv',
    meta: {
      title: '批量导入开票',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/invoicing'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  },
  {
    path: '/openPlatform',
    component: () => import('@/views/system/openPlatform'),
    name: 'openPlatform',
    meta: {
      title: '开发平台',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/openPlatform'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  },
  {
    path: '/customDtl',
    component: () => import('@/views/system/customDtl'),
    name: 'customDtl',
    meta: {
      title: '定制详情',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/invoicing'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  },
  {
    path: '/pendInvoice',
    component: () => import('@/views/rae/pendInvoice'),
    name: 'pendInvoice',
    meta: {
      title: '开票',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/invoicing'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/internalInvoice',
    component: () => import('@/views/rae/internalInvoice'),
    name: 'internalInvoice',
    meta: {
      title: '内部开票',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/invoicing'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  },
  {
    path: '/pendInvoiceMul',
    component: () => import('@/views/rae/pendInvoiceMul'),
    name: 'pendInvoiceMul',
    meta: {
      title: '开票（批量）',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/invoicing'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  },
  {
    path: '/reopen',
    component: () => import('@/views/rae/reopen'),
    name: 'reopen',
    meta: {
      title: '申请重开',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/invoicing'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  },
  {
    path: '/income',
    component: () => import('@/views/rae/income'),
    name: 'income',
    meta: {
      title: '收入',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/income'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  },
  {
    path: '/invoiceSet',
    component: () => import('@/views/rae/invoiceSet'),
    name: 'invoiceSet',
    meta: {
      title: '开票项目设置',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/invoiceSet'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  },
  {
    path: '/addInvoice',
    component: () => import('@/views/rae/addInvoice'),
    name: 'addInvoice',
    meta: {
      title: '更新开票项目',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/invoiceSet'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/acSet',
    component: () => import('@/views/projectManage/acSet'),
    name: 'acSet',
    meta: {
      title: '账套信息',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/incomeDtl',
    component: () => import('@/views/financeManage/incomeDtl'),
    name: 'incomeDtl',
    meta: {
      title: '所得明细',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/qwNotify',
    component: () => import('@/views/weCom/qwNotify'),
    name: 'qwNotify',
    meta: {
      title: '企微通知',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/register',
    component: () => import('@/views/weCom/register'),
    name: 'register',
    meta: {
      title: '登记',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/tax',
    component: () => import('@/views/financeManage/tax'),
    name: 'tax',
    meta: {
      title: '个税',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/historicalSalary',
    component: () => import('@/views/financeManage/historicalSalary'),
    name: 'historicalSalary',
    meta: {
      title: '往年薪资查询',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/deductionInfo',
    component: () => import('@/views/financeManage/deductionInfo'),
    name: 'deductionInfo',
    meta: {
      title: '扣除信息',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/taxApplySet',
    component: () => import('@/views/financeManage/taxApplySet'),
    name: 'taxApplySet',
    meta: {
      title: '个税申报设置',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/model',
    component: () => import('@/views/employee/model'),
    name: 'model',
    meta: {
      title: '示例',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/eleModelManage',
    component: () => import('@/views/employee/eleModelManage'),
    name: 'eleModelManage',
    meta: {
      title: '批量导入模板管理',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/effExportList',
    component: () => import('@/views/reportForms/effExportList'),
    name: 'effExportList',
    meta: {
      title: '效能报表导出记录',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/sysexport',
    component: () => import('@/views/system/sysexport'),
    name: 'sysexport',
    meta: {
      title: '系统导出记录',
      checked: false,
      badge: '',
      icon: 'table'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/consumerDetails',
    component: () => import('@/views/product/consumerDetails'),
    name: 'consumerDetails',
    meta: {
      title: '客户消费明细',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/bgSet'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/allCustomManage',
    component: () => import('@/views/product/allCustomManage'),
    name: 'allCustomManage',
    meta: {
      title: '客户管理',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/bgSet'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/empRosterList',
    component: () => import('@/views/employee/empRosterList'),
    name: 'empRosterList',
    meta: {
      title: '花名册（项目）',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/signupList'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/empRosterPerson',
    component: () => import('@/views/employee/empRosterPerson'),
    name: 'empRosterPerson',
    meta: {
      title: '花名册（人员）',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/signupList'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/rosterEmpDtl',
    component: () => import('@/views/employee/rosterEmpDtl'),
    name: 'rosterEmpDtl',
    meta: {
      title: '员工详情',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/signupList'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/rosterEmpEdit',
    component: () => import('@/views/employee/rosterEmpEdit'),
    name: 'rosterEmpEdit',
    meta: {
      title: '员工信息修改',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/signupList'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/bpJob',
    component: () => import('@/views/employee/bpJob'),
    name: 'bpJob',
    meta: {
      title: '伴聘岗位',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/signupList'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }, {
    path: '/rosterDtl',
    component: () => import('@/views/employee/rosterDtl'),
    name: 'rosterDtl',
    meta: {
      title: '花名册详情',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/signupList'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  },
  {
    path: '/taxInfoList',
    component: () => import('@/views/rae/taxInfoList'),
    name: 'taxInfoList',
    meta: {
      title: '人员信息采集',
      checked: false,
      badge: '',
      icon: 'table',
      activeMenu: '/taxInfoList'
    },
    powercode: "",
    powermsg: "",
    powername: ""
  }
]

const createRouter = () =>
  new Router({
    mode: 'history',
    routes: defaultRoutes
  })

const router = createRouter()
router.selfaddRoutes = function (params) {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
  router.addRoutes(params)
}
//重复点击导航 Vue重复点击相同路由
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
// router.$router.addRoutes([{path: '*', redirect: '@/views/loginItem'}]
// router.beforeEach((to, from, next) => {
//   document.title = to.meta.title ? to.meta.title : "心职";
//   next();
// });
// router.$addRoutes = function(params) {
//   router.matcher = new Router({ mode: 'history' }).matcher;
//   router.addRoutes(params)
// }
export default router